import axios from "axios";
import CacheHelper from "../helpers/cache-helper";

class PublicAPI {
  baseURL = "/api/v1/public/";
  /**
   * @constructor
   */
  constructor() {
    let app = CacheHelper.get();
    this.api = axios.create({
      baseURL: this.baseURL
    });
  }

  /**
   * Se encarga de realizar el get para recuperar los datos de la cuenta
   * que corresponde a una cuenta corriente o a un padron.
   */
  cuentas(params) {
    return this.api.get("cuentas", {
      params: params
    });
  }
  
  /**
   * Se encarga de realizar el get para recuperar los datos de los
   * departamentos
   */
  departamentos() {
    return this.api.get("departamentos", {});
  }

  /**
   * Se encarga de realizar el get para recuperar los datos de los
   * distritos
   */
  distritos() {
    return this.api.get("distritos", {});
  }
}

export default new PublicAPI();
